import { Reducer, useReducer } from "react";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const toggleReducer = (state: boolean, nextValue?: any) =>
  typeof nextValue === "boolean" ? nextValue : !state;

const useToggle = (
  initialValue: boolean
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): [boolean, (nextValue?: any) => void] => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return useReducer<Reducer<boolean, any>>(toggleReducer, initialValue);
};

export default useToggle;
